import { WhatsappLogo } from "@/components/icons"
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip"
import { useEntitlement } from "@/features/billing/hooks/use-entitlement"
import { trackEvent } from "@/lib/tracking/analytics"
import { trackFbEvent } from "@/lib/tracking/facebook-pixel"

const WhatsappSupport = () => {
  const { treatAsSubscriber } = useEntitlement()

  // Links diferentes para assinantes (parceiro incluso) e não-assinantes
  const whatsappLink = treatAsSubscriber
    ? "https://api.whatsapp.com/send/?phone=5511912435305&text=Ol%C3%A1%2C+preciso+de+ajuda+com+a+Speeke.&type=phone_number&app_absent=0"
    : "https://wa.me/message/CNBXVAFBI26LA1"

  const registerClick = () => {
    trackEvent("Clicked whatsapp support link", {
      is_subscriber: treatAsSubscriber,
    })
    trackFbEvent("WhatsappFlutuante")
  }

  return (
    <div className="fixed right-4 bottom-4 z-[1000]">
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            className="flex items-center gap-3 rounded-full bg-[#25d366] p-2 text-white shadow-md transition-all hover:scale-105 hover:bg-[#20b558] focus:ring-2 focus:ring-[#25d366] focus:ring-offset-2 focus:outline-none"
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            onClick={registerClick}
          >
            <div className="flex h-6 w-6 items-center justify-center rounded-full bg-white/10">
              <WhatsappLogo className="h-3 w-3" />
            </div>
          </a>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Suporte via WhatsApp</p>
        </TooltipContent>
      </Tooltip>
    </div>
  )
}

export default WhatsappSupport
